import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sub-menu-up-bar2',
  templateUrl: './sub-menu-up-bar2.component.html',
  styleUrls: ['./sub-menu-up-bar2.component.sass'],
})
export class SubMenuUpBar2Component implements OnInit {
  @Input('menu') menu: any;

  constructor(private router: Router) { }

  ngOnInit(): void { }

  // Adicionando método para navegar e garantir comportamento correto em mobile
  navigateTo(route: string): void {
    if (route) {
      this.router.navigate([route]);
    }
  }
}
